import { branchLocationActions } from './action.js'


const initialState = {
  //   accountTypeList:[],
  // companyTypeList: [],
  // constitutionList:[],
  // countriesList:[],
  // noOfEmployeesList: [],
  // officeInLocalityList: [],
  // officeOwnershipList:[],
  // pincodesList:[],
  branchcount: {},
  // HeadOfficeDetails:{}

}


const branchCountReducer = (state = initialState, action) => {

  switch (action.type) {


    case branchLocationActions.FETCH_BRANCH_COUNT_SUCCESS:
      return {
        ...state,
        branchcount: action.payload
      };

    case branchLocationActions.FETCH_BRANCH_COUNT_ERROR:
      return {
        ...state,
        branchcount: {}
      };
    default:
      return state;
  }

}




export default branchCountReducer